











import Vue from 'vue';
import { mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import Icon from '@/dex-shared/components/Icon.vue';

export default Vue.extend({
  components: {
    pxCard,
    Icon,
  },
  props: {
    institutionId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      institutionById: 'institutionById',
    }),
    institution() {
      return this.institutionById(this.institutionId);
    },
  },
  methods: {
    removeInstitution: async function() {
      if (
        confirm(
          'Tem certeza que deseja deletar essa instituição? Ela não poderá ser recuperada!',
        )
      ) {
        const response = await this.$store.dispatch(
          'REMOVE_INSTITUTION',
          this.institutionId,
        );

        if (response !== true) {
          //TODO analyze the error
          alert('Essa instituição não pode ser deletada!');
        }
      }
    },
  },
});
